import { workspaceModuleApi } from '../api';
import { useState } from 'react';
import { FetchStatus } from 'types/api';
import { isAxiosError } from 'axios';

export const useDeleteQa = () => {
  const [status, setDeleteStatus] = useState<FetchStatus>('idle');
  const [error, setError] = useState<string | null>(null);

  const deleteQa = async (id: number) => {
    try {
      setDeleteStatus('loading');
      await workspaceModuleApi.deleteQaItem(id);
      setDeleteStatus('success');
    } catch (error) {
      if (isAxiosError(error)) {
        setError(error.response?.data.detail || error.message);
      } else {
        setError('An error occurred');
      }
      setDeleteStatus('failed');
    }
  };
  return { status, error, deleteQa, setDeleteStatus };
};
